var EditableForm = function () {
  this.DOM = {
    IO_FORMS: '.io-form',
    IO_FORMS_ACTIONS: '.io-form-actions',
    ACTION_BUTTON_SAVE: '.io-form-action-save',
    ACTION_BUTTON_BACK: '.io-form-action-back',
    ACTION_BUTTON_TOGGLE: '.io-form-action-edit, .io-form-action-cancel',
    ACTION_BUTTON_DELETE: '.io-form-action-delete',
    LOCKED: '.locked',
    MASKED_PASSWORDS: '.mask-password',
  };
  this.initialize();
};

EditableForm.prototype.initialize = function () {
  this.ioForms = $(this.DOM.IO_FORMS);
  this._bindFormActions();

  $.each($('td.control.radio label'), function (_, label) {
    if (
      $(label).find('input[type=radio][checked]').length === 0 &&
      !$(label).hasClass('rawtext')
    ) {
      $(label).addClass('unselected');
    } else {
      $(label).removeClass('unselected');
    }
  });

  if (this.ioForms.length > 0 && $('.disabled-form').length === 0) {
    $(this.ioForms[0]).find('input:not([type=hidden]):first').trigger('focus');
  }
};

EditableForm.prototype.destroy = function () {
  for (var i = this.ioForms.length - 1; i >= 0; i--) {
    $(this.DOM.ACTION_BUTTON_TOGGLE).off('click');
    $(this.DOM.MASKED_PASSWORDS).maskPassword('destroy');
  }
};

EditableForm.prototype._bindFormActions = function () {
  var field, now, i;

  for (i = this.ioForms.length - 1; i >= 0; i--) {
    $(this.ioForms[i])
      .find(this.DOM.ACTION_BUTTON_TOGGLE)
      .on('click', this._toggleFormState.bind(this, this.ioForms[i]));

    if (this.ioForms[i].className.indexOf('disabled-form') !== -1) {
      $(this.ioForms[i])
        .find('.property .control select:enabled')
        .attr('disabled', 'disabled');
      $(this.ioForms[i])
        .find('.property .control textarea:enabled')
        .attr('disabled', 'disabled');
      $(this.ioForms[i])
        .find('.property .control input:enabled')
        .attr('disabled', 'disabled');
      $(this.ioForms[i]).find(this.DOM.MASKED_PASSWORDS).maskPassword();
    }

    field = $(this.ioForms[i]).find('[data-datepicker="true"]');

    if (field.length > 0) {
      now = new Date();

      if (field.data('utc') === true) {
        now = new Date(
          now.getUTCFullYear(),
          now.getUTCMonth(),
          now.getUTCDate(),
          now.getUTCHours(),
          now.getUTCMinutes(),
        );
      }

      $(this.ioForms[i]).find('[data-datepicker="true"]').datetimepicker({
        validateOnBlur: false,
        format: 'l, F j, Y \\a\\t H:i \\U\\T\\C ',
        minDate: 0,
        startDate: now,
        yearStart: now.getFullYear(),
        step: 15,
      });
    }
  }
};

EditableForm.prototype._toggleFormState = function (form) {
  if (form.className.indexOf('disabled-form') !== -1) {
    $(form).removeClass('disabled-form');

    if (form.className.indexOf('no-disable') === -1) {
      $(form)
        .find(
          '[disabled]:not([data-read-only=true]):not(' + this.DOM.LOCKED + ')',
        )
        .prop('disabled', false);
    }

    $.each($(form).find('td.control.radio'), function (_, radio) {
      if ($(radio).find('input[type=radio][checked]').length === 0) {
        $(radio).find('.unselect').hide();
      }
    });

    // Do not focus if the persistent actions has been triggered
    if (window.PersistentActions.initialState) {
      $(form).find('input:not([type=hidden]):first').trigger('focus');
    }

    $(form).find(this.DOM.IO_FORMS_ACTIONS).addClass('-editing');

    $(form).find(this.DOM.MASKED_PASSWORDS).maskPassword('destroy');
  } else {
    $(form).addClass('disabled-form');

    if (form.className.indexOf('no-disable') === -1) {
      $(form).find('.control input').attr('disabled', 'disabled');
    }

    $(form).find(this.DOM.MASKED_PASSWORDS).maskPassword();
  }
};

module.exports = EditableForm;
